/* eslint-disable no-empty-label */
import Utils from './../utils'

const getters = {
  storage: function() {
    return Utils.storage()
  },
  sessionStorage: function() {
    return Utils.sessionStorage()
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js